





































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Debounce } from '@/functions/debounce';
import { SortOrder } from '@/enums/SortOrder';

@Component({
  components: {
    TableRow: () => import('@/components/table/row.vue'),
  },
})
export default class TableBase extends Vue {
  @Prop() readonly data!: [];

  @Prop({ default: true }) readonly stickyHeader!: boolean;

  @Prop() readonly tableLayout!: [];

  endObserver?: IntersectionObserver;

  localData: [] = [];

  sortingOn: { key: string; order: SortOrder } | null = null;

  $refs!: {
    wrapper: HTMLElement;
    header: HTMLElement;
    body: HTMLElement;
    base: HTMLElement;
    end: HTMLElement;
  };

  mounted() {
    // @ts-ignore
    this.endObserver = new IntersectionObserver(this.onHitBottom, {
      root: this.$refs.wrapper,
      rootMargin: '200px',
    });
    this.endObserver!.observe(this.$refs.end);
  }

  unmounted() {
    this.endObserver?.disconnect();
  }

  @Emit('sort')
  handleSort({ sortable, key }: { sortable?: boolean; key: string }) {
    if (this.sortingOn?.key === key && this.sortingOn?.order === SortOrder.DESC) {
      this.sortingOn = null;
      return this.sortingOn;
    }
    if (this.sortingOn?.key === key && this.sortingOn?.order === SortOrder.ASC) {
      this.sortingOn = { key, order: SortOrder.DESC };
      return this.sortingOn;
    }
    this.sortingOn = { key, order: SortOrder.ASC };
    return this.sortingOn;
  }

  handleBodyScroll(e: { target: HTMLElement }) {
    if (!this.stickyHeader) {
      return;
    }
    const target: HTMLElement = e.target;
    if (target) {
      const header: HTMLElement | undefined = this.$refs.header;
      if (header) {
        if (target.scrollTop > 10) {
          header.style.boxShadow = `0 10px 10px -10px rgba(0, 0, 0, 0.05)`;
          header.style.borderColor = `#ecedef`;
        } else {
          header.style.boxShadow = `0 0 10px -10px rgba(0, 0, 0, 0)`;
          header.style.borderColor = `#ffffff`;
        }
      }
    }
  }

  @Watch('data', { immediate: true, deep: true })
  setLocalProducts(val: []) {
    this.localData = JSON.parse(JSON.stringify(val));
  }

  @Debounce(500)
  private onHitBottom([{ isIntersecting }]: [{ isIntersecting: boolean }]) {
    if (!isIntersecting) {
      return false;
    }
    this.$emit('hit-bottom');
    return true;
  }
}
